import React from "react";
import PropTypes from "prop-types";
import { useCurrencyContext } from "../../lib/CurrencyContext";

const CartSummary = ({ total, onCheckout, isSubmitting, error }) => {
  const { formatProductPrice } = useCurrencyContext();
  const displayTotal = formatProductPrice(total);

  return (
    <div className="pt-0 pb-7 border-t border-[#e2e2e2] bg-white">
      <div
        className="font-mono text-[14px] uppercase py-3 px-6"
        style={{
          borderBottom: "1px solid #e2e2e2",
          borderTop: "1px solid #e2e2e2",
        }}
      >
        <div className="flex items-center justify-between py-2">
          <span className="text-black/80">Shipping:</span>
          <span className="text-black/80">At Checkout</span>
        </div>
        <div className="flex items-center justify-between py-2">
          <span className="text-black/80">Total:</span>
          <span className="text-black">{displayTotal}</span>
        </div>
      </div>

      {error && (
        <p className="px-6 mt-3 text-[13px] text-red-500 font-light">{error}</p>
      )}

      <div className="flex justify-center w-full px-6 ">
        <button
          type="button"
          onClick={onCheckout}
          disabled={isSubmitting}
          className="mt-6 w-full lg:!w-7/12 h-[58px] bg-black text-white border border-black font-mono uppercase text-[15px] transition-colors hover:bg-white hover:text-black disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {isSubmitting ? "Connecting to Stripe..." : "Checkout"}
        </button>
      </div>
    </div>
  );
};

CartSummary.propTypes = {
  total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onCheckout: PropTypes.func,
  isSubmitting: PropTypes.bool,
  error: PropTypes.string,
};

CartSummary.defaultProps = {
  onCheckout: undefined,
  isSubmitting: false,
  error: null,
};

export default CartSummary;
